import React from "react";

import LegalDialog from "./LegalDialog";
import LegalDocumentContent from "./LegalDocumentContent";

interface TermsAndConditionsModalProps {
  open: boolean;
  onClose: () => void;
}

const TermsAndConditionsModal: React.FC<TermsAndConditionsModalProps> = ({
  open,
  onClose,
}) => {
  return (
    <LegalDialog
      open={open}
      onClose={onClose}
      title="Terms & Conditions"
      maxWidth="sm"
    >
      <LegalDocumentContent type="terms" />
    </LegalDialog>
  );
};

export default TermsAndConditionsModal;
